import { Stack, SxProps, Theme } from '@mui/material';
import React from 'react';
import {
  SectionBlock,
  SectionBlockProps,
  TitleBlock,
  TitleBlockProps
} from './microLayouts/titleBlock';

export const PAGE_STACK_SPACING = 7;

interface PageProps {
  readonly children: React.ReactNode;
  readonly spacing?: number;
  readonly sx?: SxProps<Theme>;
  readonly component?: 'div' | 'section' | 'main';
}

export function MainWrapper({
  children,
  spacing = PAGE_STACK_SPACING,
  sx,
  component = 'div'
}: PageProps) {
  return (
    <Stack component={component} spacing={spacing} sx={sx}>
      {children}
    </Stack>
  );
}

export function MainWrapperHeader(props: TitleBlockProps) {
  return <TitleBlock {...props} />;
}

export function MainWrapperSection(props: SectionBlockProps) {
  return <SectionBlock {...props} />;
}
